import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-table-data-field',
    templateUrl: './table-data-field.component.html',
    styleUrls: ['./table-data-field.component.scss']
})
export class TableDataFieldComponent {
    @Input() subElement;
    @Input() visibiltyConditions = [];
    @Input() shouldAppearTransclusent: boolean = false;

    constructor() {}

    ngOnInit() {
        if (this.visibiltyConditions.length > 0) {
            const trueCondition = this.visibiltyConditions.filter(
                visibilityCondition => visibilityCondition.ifCond == true
            )[0];
            if (trueCondition.length != 0) this.subElement = trueCondition.then;
        }
    }
}
